module.exports = __webpack_public_path__ + "img/lf8.dca2a17b.png";